/* eslint-disable camelcase */
/* eslint-disable array-callback-return */
/* eslint-disable no-unused-expressions */
/* eslint-disable import/order */
/* eslint-disable no-unused-expressions */
/* eslint-disable react/prop-types */
import React, { useState, useEffect, Fragment, useMemo } from 'react';
import { Link, withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import {
  Table, Select, Dropdown, Tag, Checkbox,
  Tooltip,
  Divider,
} from 'antd';
import { toISTDate } from '@Apis/constants';
import H3Button, { defaultButtonTypes } from '@Uilib/h3Button';
import H3DateSelector from '@Uilib/h3DateSelector';
import Helpers from '@Apis/helpers';
import searchIcon from '@Images/icons/icon-search.png';
import H3Text from '@Uilib/h3Text';
import dayjs from 'dayjs';
import H3Image from '@Uilib/h3Image';
import TenantSelector from '@Components/Common/Selector/TenantSelector';
import { ControlOutlined, FilterOutlined } from '@ant-design/icons';
import mrpV2Actions from '../../../../actions/production/mrpV2Actions';
import PRZText from '../../../Common/UI/PRZText';
import PRZSelect from '../../../Common/UI/PRZSelect';
import useCheckPortrait from '../../../../hooks/useCheckPortrait';
import './style.scss';
import { dateRangePresets, dateRangePresetsValues, entityNameEnum, filterTypeEnums } from '../../../../apis/constants';
import UserSavedFilterViewSelector from '../../../Common/UserSavedFilterViewSelector';

const { Option } = Select;
/**
 * @param status
 */

function MrpListV2({
  user, history, createMrpV2, createMrpV2Loading, getMrpV2, getMrpV2Loading, mrpV2,
}) {
  const [currentPage, setCurrentPage] = useState(1);
  const [limit, setLimit] = useState(10);
  const [keyword, setKeyword] = useState('');
  const [searchKeyword, setSearchKeyword] = useState('');
  const [isUserReady, setIsUserReady] = useState(false);
  const [selectedStatus, setSelectedStatus] = useState([]);
  const [selectedTenant, setSelectedTenant] = useState([]);
  const [startDateMomentEpoch, setStartDateMomentEpoch] = useState('');
  const [endDateMomentEpoch, setEndDateMomentEpoch] = useState('');
  const [fixedColumns, setFixedColumns] = useState(['PLAN_NUMBER']);
  const [currentDefaultView, setCurrentDefaultView] = useState({});
  const [currentlyAppliedFilters, setCurrentlyAppliedFilters] = useState([]);
  const [selectedFilterView, setSelectedFilterView] = useState({});
  const [isUserReadyInitial, setIsUserReadyInitial] = useState(false);
  const [isUpdateFilterSate, setIsUpdateFilterSate] = useState(true);
  const [savedFilterViews, setSavedFilterViews] = useState([]);
  const [savedFilterViewsLoading, setSavedFilterViewsLoading] = useState(false);

  const [mrpDateSelectedIntervalDateRangeType, setMrpDateSelectedIntervalDateRangeType] = useState('');

  const {
    isMobile, isPortrait, isMobileAndPortrait, isMobileOrPortrait,
  } = useCheckPortrait();

  const [visibleColumns, setVisibleColumns] = useState(localStorage.getItem('prcz-page-columns-mrp') ? JSON.parse(localStorage.getItem('prcz-page-columns-mrp')) : {
    PLAN_NUMBER: {
      label: 'Plan#',
      visible: true,
    },
    LOCATION: {
      label: 'Location',
      visible: true,
    },
    PLAN_NAME: {
      label: 'Plan Name',
      visible: true,
    },
    PLAN_DATE: {
      label: 'Plan Date',
      visible: true,
    },
    MAKE_TO_ORDERS: {
      label: 'Make To Orders(MTO)',
      visible: true,
    },
    MAKE_TO_STOCK: {
      label: 'Make To STOCK(MTS)',
      visible: true,
    },
    CREATED_DATE: {
      label: 'Created Date',
      visible: true,
    },
    PLAN_STATUS: {
      label: 'Planning Status',
      visible: true,
    },
  });

  const getMrpColumns = () => {
    const mrpColumns = [
      {
        title: '',
        render: (record) => (
          <div className="mobile-list__card">
            <div className="mobile-list__card_header">
              <div className="mobile-list__card_header-left">
                <PRZText className="mobile-list__card_item-number" text={`#${record?.mrp_number ? record.mrp_number : 'N/A'}`} />
              </div>
              <div className="mobile-list__card_header-right">
                <PRZText
                  style={{ backgroundColor: Helpers.getStatusColor(record.status).color }}
                  text={Helpers.getStatusColor(record.status).text?.toUpperCase()}
                  className="mobile-list__card__status"
                />
              </div>
            </div>
            <div className="mobile-list__card_body">
              <div className="mobile-list__card_body-left">
                <PRZText
                  text={`Location - ${record?.tenant_info?.tenant_name || ''}`}
                  className="mobile-list__card_item-details"
                />
                <PRZText
                  text={`Plan Name - ${record?.mrp_name || ''}`}
                  className="mobile-list__card_item-details"
                />
                {record?.mrp_date && (
                  <PRZText
                    text={`Plan Date - ${toISTDate(record?.mrp_date).format('DD/MM/YYYY')}`}
                    className="mobile-list__card_item-details"
                  />
                )}
                {record?.created_at && (
                  <PRZText
                    text={`Created Date - ${toISTDate(record?.created_at).format('DD/MM/YYYY')}`}
                    className="mobile-list__card_item-details"
                  />
                )}
              </div>
              <div className="mobile-list__card_body-right">
                <Tooltip
                  color="white"
                  placement="top"
                  title={(
                    <PRZText className="mobile-list__card_item__tooltip_text-color" text="Stock Items" />
                  )}
                >
                  <PRZText
                    text={record?.mrp_stock_items_count}
                    style={{ fontSize: '13px' }}
                    className="mobile-list__card_item-details"
                  />
                </Tooltip>
                <Tooltip
                  color="white"
                  placement="top"
                  title={(
                    <PRZText className="mobile-list__card_item__tooltip_text-color" text="Make To Orders" />
                  )}
                >
                  <PRZText
                    text={record?.mrp_production_count}
                    style={{ fontSize: '13px' }}
                    className="mobile-list__card_item-details"
                  />
                </Tooltip>
              </div>
            </div>
            <Divider className="mobile-list__card_divider" />
          </div>
        ),
        // responsive: ['xs'],
        hidden: !isMobile,
      },
      {
        title: 'PLAN#',
        render: (record) => (
          <div className="min-width-50">
            {record?.mrp_number}
          </div>
        ),
        responsive: ['sm', 'md', 'lg', 'xxl'],
        hidden: isMobile,
        className: !visibleColumns?.PLAN_NUMBER?.visible ? 'display-none' : '',
      },
      {
        title: 'LOCATION',
        render: (text, record) => (
          <div className="company__name min-width-70">
            {record?.tenant_info?.tenant_name}
          </div>
        ),
        responsive: ['sm', 'md', 'lg', 'xxl'],
        hidden: isMobile,
        className: !visibleColumns?.LOCATION?.visible ? 'display-none' : '',
      },
      {
        title: 'PLAN NAME',
        render: (record) => (
          <div className="min-width-70">
            {record?.mrp_name}
          </div>
        ),
        responsive: ['sm', 'md', 'lg', 'xxl'],
        hidden: isMobile,
        className: !visibleColumns?.PLAN_NAME?.visible ? 'display-none' : '',
      },
      {
        title: 'PLAN DATE',
        render: (record) => (
          <div className="min-width-85">
            {toISTDate(record?.mrp_date).format('DD/MM/YYYY')}
          </div>
        ),
        responsive: ['sm', 'md', 'lg', 'xxl'],
        hidden: isMobile,
        className: !visibleColumns?.PLAN_DATE?.visible ? 'display-none' : '',
      },
      {
        title: 'MAKE TO ORDERS(MTO)',
        render: (record) => (
          <div className="min-width-130">
            {record?.mrp_production_count}
          </div>
        ),
        responsive: ['sm', 'md', 'lg', 'xxl'],
        hidden: isMobile,
        className: !visibleColumns?.MAKE_TO_ORDERS?.visible ? 'display-none' : '',
      },
      {
        title: 'STOCK ITEMS',
        render: (record) => (
          <div className="min-width-85">
            {record?.mrp_stock_items_count}
          </div>
        ),
        responsive: ['sm', 'md', 'lg', 'xxl'],
        hidden: isMobile,
        className: !visibleColumns?.MAKE_TO_STOCK?.visible ? 'display-none' : '',
      },
      {
        title: 'CREATED DATE',
        render: (text, record) => (
          <div className="min-width-85">
            {toISTDate(record?.created_at).format('DD/MM/YYYY')}
            <H3Text text={(record?.created_by_info ? `${record?.created_by_info.first_name} ${record?.created_by_info.last_name}` : 'Unknown')} className="table-subscript" />
          </div>
        ),
        responsive: ['md', 'lg', 'xxl'],
        hidden: isMobile,
        className: !visibleColumns?.CREATED_DATE?.visible ? 'display-none' : '',
      },
      {
        title: 'PLAN STATUS',
        render: (item) => (
          <div className="associated-entity min-width-85" style={{ color: Helpers.getStatusColor(item.status).color }}>
            {Helpers.getStatusColor(item.status).text?.toUpperCase()}
          </div>
        ),
        responsive: ['sm', 'md', 'lg', 'xxl'],
        hidden: isMobile,
        className: !visibleColumns?.PLAN_STATUS?.visible ? 'display-none' : '',
      },
    ];
    mrpColumns.push({
      title: '',
      key: 'action',
      className: 'list__actions-column',
      fixed: 'right',
      render: (text, record) => (
        <div className="list__actions">
          <div
            className="list__actions-button"
            onClick={() => {
              history.push(`/production/planning/v2/view/${record.mrp_id}`);
            }}
          >
            View
          </div>
        </div>
      ),
      responsive: ['md', 'lg', 'xxl'],
      hidden: isPortrait,
    });
    return mrpColumns.filter((item) => !item.hidden);
  };

  const pushParamsToUrl = (page, lmt, status, word, start, end, tenant) => {
    let url = '';
    if (page) url += `?page=${page}`;
    if (lmt) url += `&limit=${lmt}`;
    if (status) url += `&status=${status}`;
    if (word) url += `&keyword=${word}`;
    if (start) url += `&startDate=${start}`;
    if (end) url += `&endDate=${end}`;
    if (mrpDateSelectedIntervalDateRangeType) url += `&mrp_date_type=${mrpDateSelectedIntervalDateRangeType}`;
    if (tenant) url += `&tenant=${tenant}`;
    if (selectedFilterView) url += `&filter_id=${selectedFilterView?.filter_id}`;
    history.push(url);
  };

  function getAppliedFiltersFromURL() {
    const appliedFiltersFromURL = [
      {
        filter_key: 'limit',
        filter_value: Number(Helpers.getValueFromUrl('limit') || limit),
        filter_type: filterTypeEnums.NUMBER,
      },
      {
        filter_key: 'keyword',
        filter_value: Helpers.getValueFromUrl('keyword') || '',
        filter_type: filterTypeEnums.STRING,
      },
      {
        filter_key: 'startDate',
        filter_value: Helpers.getValueFromUrl('startDate') || '',
        filter_type: filterTypeEnums.DATE_RANGE,
        date_range_type: Helpers.getValueFromUrl('mrp_date_type') || '',
      },
      {
        filter_key: 'endDate',
        filter_value: Number(Helpers.getValueFromUrl('endDate')) || '',
        filter_type: filterTypeEnums.DATE_RANGE,
        date_range_type: Helpers.getValueFromUrl('mrp_date_type') || '',
      },
      {
        filter_key: 'status',
        filter_value: Helpers.getValueFromUrl('status') ? Helpers.getValueFromUrl('status')?.split(',') : [],
        filter_type: filterTypeEnums.ARRAY,
      },
      {
        filter_key: 'tenant',
        filter_value: Helpers.getValueFromUrl('tenant') ? Helpers.getValueFromUrl('tenant')?.split(',')?.map((item) => (parseInt(item))) : [],
        filter_type: filterTypeEnums.ARRAY,
      },
    ];
    return appliedFiltersFromURL;
  }
  
  const initialFilterValues = useMemo(() => {
    return [
      {
        filter_key: 'limit',
        filter_value: limit,
        filter_type: filterTypeEnums.NUMBER,
      },
      {
        filter_key: 'keyword',
        filter_value: '',
        filter_type: filterTypeEnums.STRING,
      },
      {
        filter_key: 'startDate',
        filter_value: '',
        filter_type: filterTypeEnums.DATE_RANGE,
        date_range_type: '',
      },
      {
        filter_key: 'endDate',
        filter_value: '',
        filter_type: filterTypeEnums.DATE_RANGE,
        date_range_type: '',
      },
      {
        filter_key: 'status',
        filter_value: [],
        filter_type: filterTypeEnums.ARRAY,
      },
      {
        filter_key: 'tenant',
        filter_value: [user?.tenant_info?.tenant_id],
        filter_type: filterTypeEnums.STRING,
      },
    ];
  }, []);

  const systemDefaultUserView = useMemo(() => ({
    filter_id: 'system_default',
    filter_name: 'System Default View',
    entity_name: entityNameEnum.MATERIAL_PLANNING,
    filters: initialFilterValues,
    tenant_id: user?.tenant_info?.tenant_id,
    org_id: user?.user_org_id,
    user_id: user?.user_id,
    is_default: false,
    is_system_default: true,
  }), []);

  function getFilterValueByKey({ filtersArray, key, valueOnly = true }) {
    const selectedFilter = filtersArray.find((item) => item.filter_key === key) || null;
    return valueOnly ? selectedFilter?.filter_value : selectedFilter;
  }

  useEffect(() => {
    if (savedFilterViews && isUserReadyInitial) {
      const defaultUserView = savedFilterViews.find((item) => item.is_default);

      if (defaultUserView) {
        setCurrentDefaultView(defaultUserView);
      } else {
        setCurrentDefaultView(systemDefaultUserView);
      }

      const appliedFiltersFromURL = getAppliedFiltersFromURL();

      const selectedFilterViewFromURL = Helpers.getValueFromUrl('filter_id');

      let currentSelectedView;
      if (selectedFilterViewFromURL) {
        currentSelectedView = savedFilterViews.find((item) => String(item.filter_id) === String(selectedFilterViewFromURL));
        if (!currentSelectedView) {
          currentSelectedView = systemDefaultUserView;
        }
      } else {
        currentSelectedView = defaultUserView || systemDefaultUserView;
      }

      const filterValues = (isFromURL) => {
        const currentSelectedViewFilters = currentSelectedView.filters;

        const filterValue = initialFilterValues.map((item) => item.filter_key).reduce((acc, filterKey) => ({ ...acc, [filterKey]: getFilterValueByKey({ filtersArray: isFromURL ? appliedFiltersFromURL : currentSelectedViewFilters, key: filterKey }) }), {});

        const _orderDateRangeType = getFilterValueByKey({ filtersArray: isFromURL ? appliedFiltersFromURL : currentSelectedViewFilters, key: 'startDate', valueOnly: false }).date_range_type;

        let _orderStartDate = '';
        let _orderEndDate = '';

        if (_orderDateRangeType === '' || _orderDateRangeType === dateRangePresets.CUSTOM) {
          // No action needed for empty or custom date range type
        } else {
          const date = dateRangePresetsValues(_orderDateRangeType);
          const [start, end] = date;

          _orderStartDate = start;
          _orderEndDate = end;
          filterValue.startDate = _orderStartDate;
          filterValue.endDate = _orderEndDate;
        }

        filterValue.mrpDateRangeType = _orderDateRangeType;

        return filterValue;
      };

      const tempFilterValues = filterValues(selectedFilterViewFromURL);

      setSelectedFilterView(currentSelectedView);
      if (isUpdateFilterSate) {
        setCurrentlyAppliedFilters(appliedFiltersFromURL);

        setCurrentPage(Number(Helpers.getValueFromUrl('page') || currentPage));
        setLimit(tempFilterValues.limit || limit);
        setSearchKeyword(tempFilterValues.keyword);
        setKeyword(tempFilterValues.keyword);
        setSelectedStatus(tempFilterValues.status);
        setSelectedTenant(tempFilterValues.tenant);
        setStartDateMomentEpoch(tempFilterValues.startDate);
        setEndDateMomentEpoch(tempFilterValues.endDate);
        setMrpDateSelectedIntervalDateRangeType(tempFilterValues.mrpDateRangeType);
      }

      if (!isUserReady) setIsUserReady(true);
      if (!isUpdateFilterSate) setIsUpdateFilterSate(true);
    }
  }, [savedFilterViews, isUserReadyInitial]);

  // useEffect(() => {
  //   if (user?.tenant_info?.org_id) {
  //     setCurrentPage(Number(Helpers.getValueFromUrl('page') || currentPage));
  //     setLimit(Number(Helpers.getValueFromUrl('limit') || limit));
  //     setSelectedStatus(Helpers.getValueFromUrl('status') ? Helpers.getValueFromUrl('status')?.split(',') : []);
  //     setSearchKeyword(Helpers.getValueFromUrl('keyword'));
  //     setKeyword(Helpers.getValueFromUrl('keyword'));
  //     setStartDateMomentEpoch(Number(Helpers.getValueFromUrl('startDate')));
  //     setEndDateMomentEpoch(Number(Helpers.getValueFromUrl('endDate')));
  //     setSelectedTenant(Helpers.getValueFromUrl('tenant') ? Helpers.getValueFromUrl('tenant')?.split(',')?.map((item) => (parseInt(item))) : [user?.tenant_info?.tenant_id]);
  //     setIsUserReady(true);
  //   }
  // }, []);

  /**
 *
 */
  useEffect(() => {
    if (isUserReady) {
      pushParamsToUrl(currentPage, limit, selectedStatus, searchKeyword, startDateMomentEpoch, endDateMomentEpoch, selectedTenant, mrpDateSelectedIntervalDateRangeType, selectedFilterView);
      setCurrentlyAppliedFilters(getAppliedFiltersFromURL());
      getMrpV2({
        tenantId: (selectedTenant?.filter((item) => !isNaN(item))?.length > 0 ? selectedTenant?.join(',') : Helpers.getTenantEntityPermission(user?.user_tenants, Helpers.permissionEntities.MRP, Helpers.permissionTypes.READ)?.join(',') || user?.tenant_info?.tenant_id),
        listScreen: true,
        searchKeyword: Helpers.getValueFromUrl('keyword'),
        status: Helpers.getValueFromUrl('status'),
        fromDate: Helpers.getValueFromUrl('startDate'),
        toDate: Helpers.getValueFromUrl('endDate'),
        page: Helpers.getValueFromUrl('page'),
        limit: Helpers.getValueFromUrl('limit'),
      });
    }
  }, [selectedStatus, searchKeyword, currentPage, limit, selectedTenant, startDateMomentEpoch, endDateMomentEpoch, mrpDateSelectedIntervalDateRangeType,
    // selectedFilterView
  ]);

  const statusOptions = [
    { key: 'OPEN', value: 'OPEN', label: 'Open' },
    { key: 'CLOSED', value: 'CLOSED', label: 'Closed' },
  ];

  return (
    <Fragment>
      <div className="doc-list__wrapper">
        <div className="ant-row">
          <div className="ant-col-md-24 ant-col-xs-24">
            <div className="doc-list__header-wrapper">
              <div className="doc-list__header-wrapper__left">
                <div className="section-search">
                  <div className="doc-list__search-bar__wrapper">
                    <div className="section-search-bar">
                      <input
                        value={keyword}
                        placeholder="Search for materials plan..."
                        onKeyDown={(e) => {
                          if (e.key === 'Enter') {
                            setSearchKeyword(e.target.value);
                            setCurrentPage(1);
                          }
                        }}
                        onChange={(event) => {
                          setKeyword(event.target.value);
                        }}
                      />
                      <H3Image
                        src={searchIcon}
                        className="section-search-bar__icon"
                        alt="search"
                        onClick={() => {
                          setSearchKeyword(keyword);
                          setCurrentPage(1);
                        }}
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div className="doc-list__header-wrapper__right">
                {Helpers.getPermission(Helpers.permissionEntities.MRP,
                  Helpers.permissionTypes.CREATE, user) && (
                    <div className="doc-list__buttons-wrapper">
                      <H3Button
                        buttonType={defaultButtonTypes.BLUE_ROUNDED}
                        text="+ New Materials Plan"
                        onClick={() => {
                          createMrpV2({ tenant_id: user?.tenant_info?.tenant_id }, (data) => {
                            history.push({
                              pathname: '/production/planning/v2/create',
                              state: { id: data?.mrp_id },
                            });
                          });
                        }}
                        customClass="add-button"
                      />
                    </div>
                  )}
              </div>
            </div>
            <div className="flex-align-c" style={{ gap: '10px' }}>
              <UserSavedFilterViewSelector
                selectedFilterView={selectedFilterView}
                onChangeTab={(currentSelectedView) => {
                  setSelectedFilterView(() => {
                    const currentSelectedViewFilters = currentSelectedView.filters;

                    const filterValue = initialFilterValues.map((item) => item.filter_key).reduce((acc, filterKey) => ({ ...acc, [filterKey]: getFilterValueByKey({ filtersArray: currentSelectedViewFilters, key: filterKey }) }), {});

                    const _orderDateRangeType = getFilterValueByKey({ filtersArray: currentSelectedViewFilters, key: 'startDate', valueOnly: false }).date_range_type;

                    let _orderStartDate = '';
                    let _orderEndDate = '';

                    if (_orderDateRangeType === '' || _orderDateRangeType === dateRangePresets.CUSTOM) {
                      // No action needed for empty or custom date range type
                    } else {
                      const date = dateRangePresetsValues(_orderDateRangeType);
                      const [start, end] = date;

                      _orderStartDate = start;
                      _orderEndDate = end;
                      filterValue.startDate = _orderStartDate;
                      filterValue.endDate = _orderEndDate;
                    }

                    filterValue.mrpDateRangeType = _orderDateRangeType;

                    const tempFilterValues = filterValue;
                    setCurrentPage(1);
                    setLimit(tempFilterValues.limit || limit);
                    setSearchKeyword(tempFilterValues.keyword);
                    setKeyword(tempFilterValues.keyword);
                    setSelectedStatus(tempFilterValues.status);
                    setSelectedTenant(tempFilterValues.tenant);
                    setStartDateMomentEpoch(tempFilterValues.startDate);
                    setEndDateMomentEpoch(tempFilterValues.endDate);
                    setMrpDateSelectedIntervalDateRangeType(tempFilterValues.mrpDateRangeType);
                    return currentSelectedView;
                  });
                }}
                currentlyAppliedFilters={currentlyAppliedFilters}
                entityName={entityNameEnum.MATERIAL_PLANNING}
                setSavedFilterViews={(value) => setSavedFilterViews(value)}
                setSavedFilterViewsLoading={(value) => setSavedFilterViewsLoading(value)}
                setIsUpdateFilterSate={(value) => setIsUpdateFilterSate(value)}
                callback={() => {
                  if (!isUserReadyInitial) setIsUserReadyInitial(true);
                }}
                systemDefaultUserView={systemDefaultUserView}
              />
              <div className="header__tags">
                {searchKeyword && (
                  <Tag closable onClose={() => { setSearchKeyword(''); setKeyword(''); setCurrentPage(1); }}>
                    Search Results for
                    &nbsp;
                    <span><b><i>{searchKeyword}</i></b></span>
                  </Tag>
                )}
                {selectedTenant && selectedTenant?.map((item, index) => (
                  <Tag
                    closable
                    onClose={() => {
                      setCurrentPage(1);
                      setSelectedTenant(selectedTenant.filter((tId) => tId !== item));
                    }}
                    color="#2d7df7"
                  >
                    Business Unit -
                    &nbsp;
                    <span>
                      <b>{user?.user_tenants?.find((tenant) => tenant?.tenant_id == item)?.tenant_name?.toUpperCase()}</b>
                    </span>
                  </Tag>
                ))}
                {selectedStatus && selectedStatus?.map((item, index) => (
                  <Tag closable onClose={() => setSelectedStatus(selectedStatus.filter((tId) => tId !== item))} color="#2d7df7">
                    {' '}
                    Status -
                    &nbsp;
                    <span><b>{item?.replaceAll('_', ' ').toUpperCase()}</b></span>
                    {' '}
                  </Tag>
                ))}
                {
                  (startDateMomentEpoch && endDateMomentEpoch) ? (
                    <Tag
                      closable
                      onClose={() => {
                        setStartDateMomentEpoch(null);
                        setEndDateMomentEpoch(null);
                        setMrpDateSelectedIntervalDateRangeType('');
                      }}
                      color="#2d7df7"
                    >
                      {' '}
                      From:
                      &nbsp;
                      <span><b>{dayjs(startDateMomentEpoch).format('DD/MM/YYYY')}</b></span>
                      &nbsp;
                      To:
                      &nbsp;
                      <span><b>{dayjs(endDateMomentEpoch).format('DD/MM/YYYY')}</b></span>
                    </Tag>
                  ) : ''
                }
              </div>
            </div>  

            <div className="doc-list__table-wrapper">
              <Table
                title={() => (
                  <div className="doc-list__table-header">
                    <div className="doc-list__table-header__left">
                      <H3Text text={`${mrpV2?.count || '0'} Materials Requirement Plans`} className="" />
                    </div>
                    <div className="doc-list__table-header__right">
                      <div className="doc-list__filter-buttons">
                        <div className="doc-list__filter-buttons">
                          <H3DateSelector
                            startDate={startDateMomentEpoch}
                            endDate={endDateMomentEpoch}
                            onDateChangeWithDateRangeType={({ date, dateRangeType }) => {
                              setStartDateMomentEpoch(dayjs(date[0])?.startOf('day')?.valueOf());
                              setEndDateMomentEpoch(dayjs(date[1])?.endOf('day')?.valueOf());
                              setMrpDateSelectedIntervalDateRangeType(dateRangeType);
                            }}
                          />
                          <Dropdown
                            overlay={(
                              <div className="header__filter__container">
                                <div className="header__filter__container__title">
                                  Apply Filters
                                </div>
                                <div className="filter__container mo__header__section-status filter__container-section">
                                  <div className="filter__title"> Business Unit </div>
                                  <TenantSelector
                                    selectedTenant={selectedTenant}
                                    showSearch
                                    isMultiple
                                    onChange={(value) => {
                                      if (value === 'All') {
                                        setSelectedTenant(Helpers.getTenantEntityPermission(user?.user_tenants, Helpers.permissionEntities.MO, Helpers.permissionTypes.READ));
                                        setCurrentPage(1);
                                      } else {
                                        setSelectedTenant(value);
                                        setCurrentPage(1);
                                      }
                                    }}
                                    placeholder="Select Business Unit"
                                    hideTitle
                                    includedTenants={Helpers.getTenantEntityPermission(user?.user_tenants, Helpers.permissionEntities.MO, Helpers.permissionTypes.READ)}
                                  />
                                </div>
                                <div className="filter__container mo__header__section-status filter__container-section">
                                  <div className="filter__title">Planning Status</div>
                                  <PRZSelect
                                    value={selectedStatus}
                                    onChange={(value) => {
                                      setSelectedStatus(value);
                                      setCurrentPage(1);
                                    }}
                                    style={{ width: '100%' }}
                                    placeholder="Search by status.."
                                    mode="multiple"
                                    options={statusOptions}
                                  />
                                </div>
                              </div>
                            )}
                          >
                            <div className="action-buttons">
                              <div className="action-button">
                                <H3Text text="Filters" className="action-button-text" />
                                <FilterOutlined />
                              </div>
                            </div>
                          </Dropdown>
                          <Dropdown
                            overlay={(
                              <div className="custom-columns__content">
                                <div className="custom-columns__content-section">
                                  <H3Text text="Visible Columns" className="custom-columns__content-title" />
                                  {
                                    Object.keys(visibleColumns).filter((item) => visibleColumns[item]?.visible)?.map((key) => (
                                      <div key={key}>
                                        <Checkbox
                                          disabled={fixedColumns.includes(key)}
                                          checked={visibleColumns[key]?.visible}
                                          onChange={() => {
                                            const visibleColumnsCopy = JSON.parse(JSON.stringify(visibleColumns));
                                            visibleColumnsCopy[key].visible = !visibleColumns[key].visible;
                                            localStorage.setItem('prcz-page-columns-mrp', JSON.stringify(visibleColumnsCopy));
                                            setVisibleColumns(visibleColumnsCopy);
                                          }}
                                        >
                                          {visibleColumns[key]?.label}
                                        </Checkbox>
                                      </div>
                                    ))
                                  }
                                </div>
                                {Object.keys(visibleColumns).filter((item) => !visibleColumns[item]?.visible)?.length ? (
                                  <div className="custom-columns__content-section">
                                    <H3Text text="Hidden Columns" className="custom-columns__content-title" />
                                    {
                                      Object.keys(visibleColumns).filter((item) => !visibleColumns[item]?.visible)?.map((key) => (
                                        <div key={key}>
                                          <Checkbox
                                            disabled={fixedColumns.includes(key)}
                                            checked={visibleColumns[key]?.visible}
                                            onChange={() => {
                                              const visibleColumnsCopy = JSON.parse(JSON.stringify(visibleColumns));
                                              visibleColumnsCopy[key].visible = !visibleColumns[key].visible;
                                              localStorage.setItem('prcz-page-columns-mrp', JSON.stringify(visibleColumnsCopy));
                                              setVisibleColumns(visibleColumnsCopy);
                                            }}
                                          >
                                            {visibleColumns[key]?.label}
                                          </Checkbox>
                                        </div>
                                      ))
                                    }
                                  </div>
                                ) : ''}
                              </div>
                            )}
                            trigger={['click']}
                            placement="bottomRight"
                          >
                            <div className="custom-columns__wrapper">
                              Customize Columns
                              <ControlOutlined />
                            </div>
                          </Dropdown>
                        </div>
                      </div>
                    </div>
                  </div>
                )}
                bordered
                loading={getMrpV2Loading || createMrpV2Loading}
                showHeader
                size="small"
                scroll={!isMobileOrPortrait && !!mrpV2?.mrp_plans?.length ? { x: 'max-content', y: 'calc(100dvh - 160px)' } : { x: 'max-content' }}
                sticky={!isMobileOrPortrait && !!mrpV2?.mrp_plans?.length}
                columns={getMrpColumns()}
                dataSource={mrpV2?.mrp_plans ? mrpV2?.mrp_plans?.map((item) => ({
                  ...item,
                  key: item?.mrp_id,
                })) : []}
                pagination={
                  {
                    defaultCurrent: currentPage,
                    current: currentPage,
                    total: mrpV2?.count || 0,
                    pageSize: limit,
                    onChange: (page, pageSize) => {
                      setCurrentPage(page);
                      setLimit(pageSize);
                    },
                    position: ['bottomLeft'],
                    showTotal: (tot, range) => `${range[0]}-${range[1]} of ${tot} items`,
                    showSizeChanger: true,
                    pageSizeOptions: [10, 25, 50, 100],
                  }
                }
              />
            </div>
          </div>
        </div>
      </div>
    </Fragment>
  );
}

const mapStateToProps = ({
  UserReducers, MrpV2Reducers,
}) => ({
  user: UserReducers.user,
  getMrpRunsLoading: MrpV2Reducers.getMrpRunsLoading,
  createMrpV2Loading: MrpV2Reducers.createMrpV2Loading,
  mrpV2: MrpV2Reducers.mrpV2,
  getMrpV2Loading: MrpV2Reducers.getMrpV2Loading,
});

const mapDispatchToProps = (dispatch) => ({
  createMrpV2: (payload, callback) => dispatch(mrpV2Actions.createMrpV2(payload, callback)),
  getMrpV2: (payload, callback) => dispatch(mrpV2Actions.getMrpV2(payload, callback)),
});

MrpListV2.propTypes = {
  user: PropTypes.any,
  history: PropTypes.any,
  createMrpV2Loading: PropTypes.bool,
  createMrpV2: PropTypes.func,
  getMrpV2: PropTypes.func,
  getMrpV2Loading: PropTypes.bool,
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(MrpListV2));
